<template>
  <div>
    <Head :title="title" />
    <div class="max-w-full bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Name')" is_required />
          <text-input v-model="form.slug" :error="form.errors.slug" class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Slug')" is_required />
        </div>
        <div class="px-8 pb-8">
          <h3 class="font-bold mb-4">{{ __('Access') }}</h3>
          <div class="overflow-x-auto border rounded-md">
            <table class="w-full whitespace-nowrap">
              <tr class="text-left font-bold bg-gray-50">
                <th class="py-2 px-4">{{ __('Module') }}</th>
                <th class="py-2 px-4">{{ __('Read') }}</th>
                <th class="py-2 px-4">{{ __('Create') }}</th>
                <th class="py-2 px-4">{{ __('Update') }}</th>
                <th class="py-2 px-4">{{ __('Delete') }}</th>
              </tr>
              <tr v-for="module in modules" :key="module" class="border-t">
                <td class="py-2 px-4">{{ __(moduleLabel(module)) }}</td>
                <td class="py-2 px-4"><input type="checkbox" v-model="form.access[module].read" /></td>
                <td class="py-2 px-4"><input type="checkbox" v-model="form.access[module].create" /></td>
                <td class="py-2 px-4"><input type="checkbox" v-model="form.access[module].update" /></td>
                <td class="py-2 px-4"><input type="checkbox" v-model="form.access[module].delete" /></td>
              </tr>
            </table>
          </div>
          <div v-if="form.errors.access" class="form-error mt-2">{{ form.errors.access }}</div>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">
            {{ __('Delete Role') }}
          </button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">{{ __('Update Role') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

const MODULES = [
  'role', 'user', 'card', 'landing_page', 'resume', 'link_in_bio', 'lead', 'lead_form',
  'blog', 'faq', 'knowledge_base', 'global', 'language', 'type', 'license',
  'chat', 'smtp', 'pusher', 'status', 'ticket', 'contact', 'category', 'customer',
  'priority', 'department', 'front_page', 'organization', 'email_template',
]

function normalizeAccess(access) {
  return MODULES.reduce((normalized, module) => {
    normalized[module] = {
      read: !!access?.[module]?.read,
      create: !!access?.[module]?.create,
      update: !!access?.[module]?.update,
      delete: !!access?.[module]?.delete,
    }
    return normalized
  }, {})
}

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  props: {
    role: Object,
    title: String,
  },
  remember: 'form',
  data() {
    return {
      modules: MODULES,
      form: this.$inertia.form({
        _method: 'put',
        name: this.role.name,
        slug: this.role.slug,
        access: normalizeAccess(this.role.access),
      }),
    }
  },
  methods: {
    moduleLabel(module) {
      return module.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')
    },
    update() {
      this.form.post(this.route('roles.update', this.role.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this role?')) {
        this.$inertia.delete(this.route('roles.destroy', this.role.id))
      }
    },
  },
}
</script>
